/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingLineItemIdentityPlus extends models.BillingLineItemIdentity {
    getFixupPrototypeFunction() { return BillingLineItemIdentityPlus.fixupPrototype; }

    static newInstance(model: Partial<BillingLineItemIdentityPlus>): BillingLineItemIdentityPlus {
        let obj = Object.assign(new BillingLineItemIdentityPlus(), model);
        BillingLineItemIdentityPlus.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingLineItemIdentityPlus>): BillingLineItemIdentityPlus {
        if (!model) return null;
        return BillingLineItemIdentityPlus.newInstance(<BillingLineItemIdentityPlus> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingLineItemIdentityPlus) {
        if (!obj) return;

        models.BillingLineItemIdentityPlus.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingLineItemIdentityPlus): boolean {
        if (models.BillingLineItemIdentity.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingLineItemIdentityPlus.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Service name
     */
    service_name: string;

    /**
     * Tenant ID
     */
    tenant_id: string;

}
